import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_home/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/general', replace: true });
  },
});
